import { useParams } from 'react-router-dom'
import EditTaskBaseForm from './EditTaskBaseForm'

import { useGetTaskBasesQuery } from './taskBasesApiSlice'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetCoursesQuery } from '../courses/coursesApiSlice'
const EditTaskBase = () => {
    useTitle('geshtop-Exercise: Edit TaskBase')

    const { taskBaseId } = useParams()
    const { username, isTeacher, isAdmin } = useAuth()

    const { taskBase } = useGetTaskBasesQuery("taskBasesList", {
        selectFromResult: ({ data }) => {
            return {
                taskBase: data?.find(x=>x._id ===taskBaseId)
            }
        },
    })

    const { courses } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!taskBase || !courses) return <PulseLoader color={"#FFF"} />

    // if (!isTeacher && !isAdmin) {
    //     if (taskBase.username !== username) {
    //         return <p className="errmsg">No access</p>
    //     }
    // }
    const content =
    <>
    <EditTaskBaseForm taskBase={taskBase} courses={courses} />  
       
    </>

    return content
}
export default EditTaskBase